// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-section[data-v-77124b0a]{padding-left:.2rem;padding-right:.2rem;height:100%}", ""]);
// Exports
module.exports = exports;
